import React, { useState, useEffect } from 'react'
import UpdateForm from './UpdateForm';
import { Button, Typography } from '@mui/material';
import { Modal, Accordion } from 'react-bootstrap'

export default function FleetDescription() {
    const [createNewFlag, setCreateNewFlag] = useState(false)
    const [lgShow, setLgShow] = useState(false);
    const [accessType, setAccessType] = useState('')

    //API call
    useEffect(() => {

        const loggedInUser = sessionStorage.getItem("user_token");
        const foundUser = JSON.parse(loggedInUser);

        if (foundUser.role_capabilities?.all_modules_access === true) {

            setAccessType('Edit');

        }
        else {

            setAccessType(foundUser.access['FleetDescription_Access Specifier']);
        }

    }, []);


    return (
        <>
            <div className="row">
                <div className="row my-3 ">
                    <div className="col-md-6">
                        <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
                            Fleet Description {accessType === 'View' && "/ View Only Mode"}
                        </Typography>
                    </div>

                    <div className="col-md-6 d-flex justify-content-end">
                        <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
                        <Modal
                            size="lg"
                            show={lgShow}
                            onHide={() => setLgShow(false)}
                            aria-labelledby="example-modal-sizes-title-lg">
                            <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
                                <Modal.Title id="example-modal-sizes-title-lg" >
                                    Instructions to Add/Edit Fleet Description
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body style={{ backgroundColor: '#F8FAFC', padding: '24px' }}>
                                <style>{`
                                  .help-badge {
                                    padding: 4px 10px;
                                    border-radius: 16px;
                                    font-weight: 700;
                                    font-size: 12px;
                                    text-transform: uppercase;
                                    letter-spacing: 0.5px;
                                    margin-right: 10px;
                                  }
                                  .badge-create { background: #e6fffa; color: #234e52; border: 1px solid #b2f5ea; }
                                  .badge-update { background: #fffaf0; color: #9c4221; border: 1px solid #feebc8; }
                                  .badge-delete { background: #fff5f5; color: #9b2c2c; border: 1px solid #fed7d7; }
                                  
                                  .help-card-text {
                                    font-size: 14px;
                                    color: #4a5568;
                                    line-height: 1.5;
                                    margin-bottom: 16px;
                                  }
                                  .video-responsive-wrapper {
                                    position: relative;
                                    width: 100%;
                                    padding-top: 56.25%; /* 16:9 Aspect Ratio */
                                    border-radius: 8px;
                                    overflow: hidden;
                                    background: #000000;
                                  }
                                  .video-responsive-wrapper video {
                                    position: absolute;
                                    top: 0;
                                    left: 0;
                                    width: 100%;
                                    height: 100%;
                                    object-fit: contain;
                                  }
                                  .accordion-button:not(.collapsed) {
                                    background-color: #f1f5f9;
                                    color: #1e293b;
                                  }
                                `}</style>

                                <Accordion defaultActiveKey="0" flush>

                                  {/* 1. CREATE FLEET DESCRIPTION */}
                                  <Accordion.Item eventKey="0" className="mb-2 border rounded">
                                    <Accordion.Header>
                                      <span className="help-badge badge-create">Create</span>
                                      <strong>How to Create a Car Class</strong>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <p className="help-card-text">
                                        To create a new Car Class, select the <strong>Account Name</strong> and <strong>Location Name</strong> from the dropdown, then select the <strong>SIPP Code</strong>. Enter the Make, Model, Vehicle Size, Seat Count, Door Count, Vehicle Category, Description, Car Image, Inventory, Ceiling Price, and Steering Side, then click <strong>Submit</strong>.
                                      </p>
                                      <div className="video-responsive-wrapper">
                                        <video controls preload="metadata" playsInline>
                                          <source src="https://d1efa1i7wh44gq.cloudfront.net/fleet - create.mp4" type="video/mp4" />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>

                                  {/* 2. UPDATE FLEET DESCRIPTION */}
                                  <Accordion.Item eventKey="1" className="mb-2 border rounded">
                                    <Accordion.Header>
                                      <span className="help-badge badge-update">Update</span>
                                      <strong>How to Edit a Car Class</strong>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <p className="help-card-text">
                                        To update an existing Car Class, select the <strong>Account Name</strong> and <strong>Location Name</strong>, choose the required SIPP Code, and edit the existing details as needed. The Added By and Edited By information is also displayed in the View/Edit section.
                                      </p>
                                      <div className="video-responsive-wrapper">
                                        <video controls preload="metadata" playsInline>
                                          <source src="https://d1efa1i7wh44gq.cloudfront.net/fleet - edit.mp4" type="video/mp4" />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>

                                  {/* 3. DELETE FLEET DESCRIPTION */}
                                  <Accordion.Item eventKey="2" className="mb-2 border rounded">
                                    <Accordion.Header>
                                      <span className="help-badge badge-delete">Delete</span>
                                      <strong>How to Delete a Car Class</strong>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                      <p className="help-card-text">
                                        Select the required account and location, hover over the car class row to delete, click the <strong>Delete icon</strong>, and confirm the pop-up prompt to permanently delete the car class.
                                      </p>
                                      <div className="video-responsive-wrapper">
                                        <video controls preload="metadata" playsInline>
                                          <source src="https://d1efa1i7wh44gq.cloudfront.net/fleet - delete.mp4" type="video/mp4" />
                                          Your browser does not support the video tag.
                                        </video>
                                      </div>
                                    </Accordion.Body>
                                  </Accordion.Item>

                                </Accordion>
                            </Modal.Body>
                        </Modal>
                    </div>
                </div>
            </div>

            {accessType === 'View' ? <UpdateForm accessType={accessType} /> : <UpdateForm />}
        </>
    );
}
